import { createSlice } from '@reduxjs/toolkit';
import { handleRequestThunk } from '../../handleRequestThunk';
import { getNameServices } from '../thunks/servicesThunks';
import { commonInitialState } from '../../../../utils/common/commonInitialState';
import { clearServicesKey } from '../thunkKeys/servicesThunksKeys';

const SLICE_NAME = 'nameServices';

export const nameServicesSlice = createSlice({
    name: SLICE_NAME,
    initialState: structuredClone(commonInitialState),
    reducers: {
        clearNameServices(state) {
            state.data = [];
        },
    },
    extraReducers: (builder) => {
        handleRequestThunk({ builder, request: getNameServices });
        builder.addCase(
            clearServicesKey,
            () => commonInitialState,
        );
    },
});

export const { clearNameServices } = nameServicesSlice.actions;

export const nameServices = nameServicesSlice.reducer;
